import { Box, Typography, Button, Paper } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Error as ErrorOutlineIcon, Lock as LockOutlineIcon, SearchOff as SearchOffIcon } from '@mui/icons-material'

interface ErrorPageProps {
  code: 403 | 404 | 500
}

const ERROR_CONFIG: Record<number, { icon: typeof ErrorOutlineIcon; title: string; description: string }> = {
  403: {
    icon: LockOutlineIcon,
    title: '无权访问',
    description: '您没有权限访问此页面，请联系管理员获取权限。',
  },
  404: {
    icon: SearchOffIcon,
    title: '页面未找到',
    description: '您访问的页面不存在，请检查地址是否正确。',
  },
  500: {
    icon: ErrorOutlineIcon,
    title: '服务器错误',
    description: '服务器遇到了一个错误，请稍后重试。如果问题持续存在，请联系管理员。',
  },
}

export function ErrorPage({ code }: ErrorPageProps) {
  const navigate = useNavigate()
  const config = ERROR_CONFIG[code]
  const Icon = config.icon

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        bgcolor: 'background.default',
      }}
    >
      <Paper
        sx={{
          p: 5,
          maxWidth: 480,
          textAlign: 'center',
          borderRadius: 3,
        }}
        elevation={0}
      >
        <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
          <Icon sx={{ fontSize: 64, color: 'text.secondary' }} />
          <Typography
            variant="h3"
            sx={{
              position: 'absolute',
              bottom: -4,
              right: -16,
              fontWeight: 800,
              color: 'primary.main',
              fontSize: '1.2rem',
              bgcolor: 'background.paper',
              borderRadius: '50%',
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid',
              borderColor: 'divider',
            }}
          >
            {code}
          </Typography>
        </Box>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          {config.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {config.description}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            返回上页
          </Button>
          <Button variant="contained" onClick={() => navigate('/')}>
            返回首页
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
